// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__0ZE0a","box":"Timer_box__irxHn","seconds":"Timer_seconds__qhm5t","large":"Timer_large__IIB5y","medium":"Timer_medium__hXmVM"};